import { FormCard } from '@qbe/ads-blocks-forms';
import React from 'react';
import { Outlet } from 'react-router-dom';

import { useAppContent } from '~/hooks';

const ExtraInfo: React.FC = () => {
  const { getTextContent } = useAppContent({
    basePath: 'dsme.extraInfo',
  });
  return (
    <>
      <FormCard
        description={getTextContent('description')}
        title={getTextContent('title')}
        data-testid="extra-info"
        variant="pageTitle"
      />
      <Outlet />
    </>
  );
};

export default ExtraInfo;
